import {
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ClientConfigClass;
function ClientConfig() {
  if (ClientConfigClass === VOID) {
    class $ {
      constructor(prereleaseMode, auth0ClientId, auth0Domain, basename, expressEnv, webpackPublicPath, websocketHost) {
        this.u7c_1 = prereleaseMode;
        this.v7c_1 = auth0ClientId;
        this.w7c_1 = auth0Domain;
        this.x7c_1 = basename;
        this.y7c_1 = expressEnv;
        this.z7c_1 = webpackPublicPath;
        this.a7d_1 = websocketHost;
      }
      toString() {
        return 'ClientConfig(prereleaseMode=' + this.u7c_1 + ', auth0ClientId=' + this.v7c_1 + ', auth0Domain=' + this.w7c_1 + ', basename=' + this.x7c_1 + ', expressEnv=' + this.y7c_1 + ', webpackPublicPath=' + this.z7c_1 + ', websocketHost=' + this.a7d_1 + ')';
      }
      hashCode() {
        var result = getBooleanHashCode(this.u7c_1);
        result = imul(result, 31) + getStringHashCode(this.v7c_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.w7c_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.x7c_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.y7c_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.z7c_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.a7d_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ClientConfig()))
          return false;
        if (!(this.u7c_1 === other.u7c_1))
          return false;
        if (!(this.v7c_1 === other.v7c_1))
          return false;
        if (!(this.w7c_1 === other.w7c_1))
          return false;
        if (!(this.x7c_1 === other.x7c_1))
          return false;
        if (!(this.y7c_1 === other.y7c_1))
          return false;
        if (!(this.z7c_1 === other.z7c_1))
          return false;
        if (!(this.a7d_1 === other.a7d_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ClientConfig');
    ClientConfigClass = $;
  }
  return ClientConfigClass;
}
//region block: exports
export {
  ClientConfig as ClientConfig2mpft8d5d0hh3,
};
//endregion

//# sourceMappingURL=ClientConfig.mjs.map
